import BzbsProfile from "@/core/Account/service/BzbsProfile";

export default function (states) {
    const loadUserProfile = function () {
        return new Promise((resolve, reject) => {
            BzbsProfile.getProfile(states.query.token).subscribe({
                next: (profile) => {
                    states.profile = profile.profile
                    states.isLogin = true;
                    resolve(profile)
                },
                error: (err) => {
                    states.profile = null
                    reject(err)
                }
            })
        })
    }

    return {
        loadUserProfile
    }
}
